export default {"src":"/polygon/_next/static/media/matic-dark.5b34daf7.svg","height":28,"width":28};